import { computed, useNuxtApp, useState } from "#imports";
export function useEasyTexts() {
  const { $texts, $textsPlural } = useNuxtApp();
  const isDebugState = useState(
    "nuxt_easy_texts_debug_enabled",
    () => false
  );
  const isDebug = computed(() => isDebugState.value);
  function enableDebug() {
    isDebugState.value = true;
  }
  function disableDebug() {
    isDebugState.value = false;
  }
  function toggleDebug() {
    isDebugState.value = !isDebugState.value;
  }
  return {
    $texts,
    $textsPlural,
    isDebug,
    enableDebug,
    disableDebug,
    toggleDebug
  };
}
